import React from "react";

const FormResponseFormatToUser = ({
  data,
  companyName = "Mento",
  companyLogo = "https://i.postimg.cc/RvWYycTG/mento-Logo-ICON.png",
}) => {
  const name = data.name

  return (
    <div
      style={{
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        maxWidth: "600px",
        margin: "0 auto",
        backgroundColor: "#ffffff",
        color: "#333",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 5px 20px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
          padding: "30px 20px",
          textAlign: "center",
          color: "white",
        }}
      >
        <img
          src={companyLogo}
          alt={companyName}
          style={{
            maxHeight: "60px",
            marginBottom: "15px",
          }}
        />
        <h1
          style={{
            fontSize: "26px",
            fontWeight: "600",
            margin: "0",
            color: "white",
          }}
        >
          Form Submitted Successfully!
        </h1>
        <p
          style={{
            fontSize: "16px",
            marginTop: "10px",
          }}
        >
          You're just One Step Away from Your First Session.

        </p>
      </div>

      {/* Message */}
      <div style={{ padding: "30px 40px" }}>
        <p
          style={{
            fontSize: "17px",
            lineHeight: "1.6",
          }}
        >
          {/* Hi <span style={{ fontWeight: '600', color: '#6a11cb' }}>{name}</span>, */}
          Hi <span style={{ fontWeight: "600", color: "#6a11cb" }}>{name}</span>,
        </p>

        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
          }}
        >
          Thank you for filling out the form and taking the first step toward
          prioritizing your mental well-being.
        </p>

        <p
          style={{
            fontSize: "16px",
            marginTop: "25px",
            lineHeight: "1.6",
          }}
        >
         We’ve received your details. Our team will be reaching out to you shortly to understand your concerns better and guide you through the next steps.
        </p>
        <p
          style={{
            fontSize: "16px",
            marginTop: "25px",
            lineHeight: "1.6",
          }}
        >
          Please note your session can be scheduled once your payment is
          completed. Once it’s done, we’ll reserve your slot and connect you
          with the right therapist for your needs.
        </p>

        <p
          style={{
            fontSize: "16px",
            marginTop: "25px",
            lineHeight: "1.6",
          }}
        >
          If you have any questions or need help with the payment process, feel
          free to chat with our representative here.
        </p>
        {/* Footer / CTA */}
        <div
          style={{
            marginTop: "30px",
            textAlign: "center",
          }}
        >
          <a
            href="https://wa.me/+919120719120"
            style={{
              background: 'linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)',
              color: '#ffffff',
              padding: '12px 26px',
              borderRadius: '30px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '15px'
            }}>
            Visit Our Website
          </a>
          <div className="contact-info-MN">
          <p>If you have any questions, please contact us at:</p>
          <p>
            <strong>connectmento@gmail.com</strong> or call{" "}
            <button onClick={() => (window.location.href = "https://wa.me/9120719120")}></button>
          </p>
        </div>
        </div>
      </div>
    </div>
  );
};

const GenerateEmailHTML = (email_content) => {
  return `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Email Confirmation</title>
        <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px; background-color: #f8f9fa; color: #333; }
        </style>
    </head>
    <body>
        ${email_content}
    </body>
    </html>`;
};

const UserPaymentConfirmationToMento = ({ data = {} }) => {
  // Sample data for preview (will be replaced by actual data in production)
  const sampleData = {
    transactionID: data.upiTransactionId,
    amount: data.amount/100,
    recipientName: data.account_name,
    paymentMethod: data.type,
    status: 'Completed',
    
    ...data
  };
  
  const currentDate = data.date || new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  // Format key for display (convert camelCase to Title Case with spaces)
  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/(Id|ID)$/i, 'ID')
      .trim();
  };


  return (
    <div
      style={{
        width: "360px",
        margin: "20px auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 5px 20px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e0e0e0",
        overflow: "hidden"
      }}
    >
      {/* Header */}
      <div style={{ backgroundColor: "#007457", padding: "16px", color: "#fff" }}>
        <h3 style={{ margin: 0 }}>Payment Received Notification</h3>
        <span style={{ float: "right", fontSize: "14px" }}>Mento</span>
      </div>

      {/* Content */}
      <div style={{ padding: "20px" }}>
        <div
          style={{
            backgroundColor: "#e6f4ea",
            border: "1px solid #c1e1c1",
            color: "#2e7d32",
            padding: "10px 14px",
            borderRadius: "8px",
            fontSize: "14px",
            marginBottom: "20px",
          }}
        >
          ✅ Payment Successfully Received
        </div>

        <p style={{ fontSize: "16px", marginBottom: "6px" }}>
          A payment has been successfully received from <strong>{data.name}</strong>.
        </p>
        <h2 style={{ margin: "0 0 10px", fontSize: "28px", color: "#1a1a1a" }}>
  {Number(data.amount).toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
  })}
</h2>

        <p style={{ fontSize: "14px", color: "#555" }}>for {data.type}</p>

        {/* Details */}
        <div style={{ marginTop: "20px", borderTop: "1px solid #eee", paddingTop: "12px" }}>
          <p><strong>Amount</strong><br />{data.amount}</p>
          <p><strong>Email </strong><br />{data.email}</p>
          <p><strong>Name</strong><br />{data.name}</p>
          <p><strong>Number</strong><br />{data.number}</p>
          <p><strong>submitted_date</strong><br />{data.submitted_date}</p>
          <p><strong>Type</strong><br />{data.type}</p>
          <p><strong>upiTransactionId</strong><br />{data.upiTransactionId}</p>
          <p><strong>utrNumber</strong><br />{data.utr}</p>
          <p><strong>merchantTransactionId</strong><br />{data.merchantTransactionId}</p>

          <p><strong>transactionId</strong><br />{data.transactionId}</p>
          <p><strong>ifsc code</strong><br />{data.ifsc}</p>

        </div>

        {/* Admin Message */}
        <div style={{ backgroundColor: "#fff8e1", padding: "12px", borderRadius: "8px", marginTop: "20px", fontSize: "14px" }}>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
          
        </div>

        {/* Footer */}
      
      </div>
    </div>
  );

};





const FormResponseFormatToMento1 = (
  data,
  companyName = "Mento",
  companyLogo = "https://i.postimg.cc/RvWYycTG/mento-Logo-ICON.png"
) => {
  const formatValue = (value) => {
    if (typeof value === "object" && value !== null) {
      return (
        <pre
          style={{
            backgroundColor: "#f9f9f9",
            padding: "10px",
            borderRadius: "4px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontSize: "13px",
          }}
        >
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    }
    return String(value);
  };

  return (
    <div
      style={{
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        maxWidth: "600px",
        margin: "0 auto",
        backgroundColor: "#ffffff",
        color: "#333333",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #00b09b 0%, #96c93d 100%)",
          padding: "20px",
          textAlign: "center",
          color: "white",
        }}
      >
        <img
          src={companyLogo}
          alt={companyName}
          style={{ maxHeight: "50px", marginBottom: "10px" }}
        />
        <h1 style={{ fontSize: "24px", margin: "5px 0", fontWeight: "600" }}>
          New Form Submission
        </h1>
      </div>

      {/* Body */}
      <div style={{ padding: "25px" }}>
        <p style={{ fontSize: "16px", lineHeight: "1.5", marginTop: "0" }}>
          A new consultation form has been submitted. Here are the key details:
        </p>

        <div
          style={{
            backgroundColor: "#f0fdf4",
            padding: "20px",
            borderRadius: "8px",
            margin: "20px 0",
            boxShadow: "0 2px 5px rgba(0, 176, 155, 0.1)",
            borderLeft: "4px solid #00b09b",
          }}
        >
          <h3
            style={{
              margin: "0 0 15px 0",
              color: "#00b09b",
              fontSize: "18px",
            }}
          >
            Submission Details
          </h3>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              {Object.entries(data).map(([key, value], index) => (
                <tr key={index}>
                  <td
                    style={{
                      padding: "10px",
                      fontWeight: "600",
                      width: "35%",
                      verticalAlign: "top",
                      textTransform: "capitalize",
                    }}
                  >
                    {key.replace(/([A-Z])/g, " $1")}:
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      wordBreak: "break-word",
                    }}
                  >
                    {formatValue(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Action Button */}
        {data.email && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              margin: "25px 0",
            }}
          >
            <a
              href={`mailto:${data.email}?subject=Regarding%20Your%20${companyName}%20Consultation%20Request`}
              style={{
                background: "#00b09b",
                color: "white",
                padding: "10px 20px",
                borderRadius: "4px",
                textDecoration: "none",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              Contact User
            </a>
          </div>
        )}

        {/* Note */}
        <div
          style={{
            backgroundColor: "#f5f5f5",
            padding: "15px",
            borderRadius: "6px",
            fontSize: "14px",
            marginTop: "20px",
          }}
        >
          <p style={{ margin: "0", lineHeight: "1.5" }}>
            To access the full submission details and take necessary actions,
            please log in to your admin dashboard.
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            borderTop: "1px solid #e1e1e1",
            paddingTop: "20px",
            marginTop: "25px",
            textAlign: "center",
            color: "#666666",
            fontSize: "13px",
          }}
        >
          <p style={{ margin: "0 0 10px 0" }}>
            This is an automated notification. Please do not reply to this
            email.
          </p>
        </div>
      </div>
    </div>
  );
};




const UserPaymentConfirmation = ({ data = {} }) => {
  // Filter out unnecessary fields and prepare data for display
  const filteredData = { ...data };
  if (filteredData.companyName) delete filteredData.companyName;
  
  // Format key for display (convert camelCase to Title Case with spaces)
  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/(Id|ID)$/i, 'ID')
      .trim();
  };

  // Sample data for preview (will be replaced by actual data in production)
  const sampleData = {
    transactionID: data.PhonepaytransactionID,
    amount: data.amount,
    senderName: data.name,
    paymentMethod: data.type,
    status: 'Completed',
    ...filteredData
  };
  
  const currentDate = data.date || new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <div
      style={{
        width: "360px",
        margin: "20px auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 5px 20px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e0e0e0",
        overflow: "hidden"
      }}
    >
      {/* Header */}
      <div style={{ backgroundColor: "#007457", padding: "16px", color: "#fff" }}>
        <h3 style={{ margin: 0 }}>Payment Receipt</h3>
        <span style={{ float: "right", fontSize: "14px" }}>Mento</span>
      </div>

      {/* Content */}
      <div style={{ padding: "20px" }}>
        <div
          style={{
            backgroundColor: "#e6f4ea",
            border: "1px solid #c1e1c1",
            color: "#2e7d32",
            padding: "10px 14px",
            borderRadius: "8px",
            fontSize: "14px",
            marginBottom: "20px",
          }}
        >
          ✅ Payment Successfully Sent
        </div>

        <p style={{ fontSize: "16px", marginBottom: "6px" }}>
          Thank you for your payment, <strong>{data.name}</strong>!
        </p>
        <h2 style={{ margin: "0 0 10px", fontSize: "28px", color: "#1a1a1a" }}>
  {Number(data.amount).toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
  })}
</h2>
        <p style={{ fontSize: "14px", color: "#555" }}>to {data.type}</p>

        {/* Details */}
        <div style={{ marginTop: "20px", borderTop: "1px solid #eee", paddingTop: "12px" }}>
          <p><strong>Transaction ID</strong><br />{data.transactionId}</p>
          <p><strong>Payment Method</strong><br />{data.type}</p>
          <p><strong>Date & Time</strong><br />{data.submitted_date}</p>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        
        </div>

        {/* Footer */}
        <p
          style={{
            fontSize: "12px",
            color: "#777",
            textAlign: "center",
            marginTop: "20px",
            borderTop: "1px solid #eee",
            paddingTop: "12px",
          }}
        >
          This is a confirmation of your payment to Mento. Please save this receipt for your records.
        </p>
      </div>
    </div>
  
  );
};

const FromResponseFormatToContactus = (data, companyName = "Mento") => {
  return (
    <div
      style={{
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        maxWidth: "600px",
        margin: "0 auto",
        padding: "0",
        backgroundColor: "#ffffff",
        color: "#333333",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Header with gradient */}
      <div
        style={{
          background: "linear-gradient(135deg, #00b09b 0%, #96c93d 100%)",
          padding: "20px",
          textAlign: "center",
          color: "white",
        }}
      >
        <h1
          style={{
            fontSize: "24px",
            margin: "5px 0",
            fontWeight: "600",
          }}
        >
          New Contact Form Submission
        </h1>
        <p style={{ margin: "5px 0" }}>{new Date().toLocaleString()}</p>
      </div>

      {/* Content area */}
      <div style={{ padding: "25px" }}>
        <p style={{ fontSize: "16px", lineHeight: "1.5", marginTop: "0" }}>
          You have received a new contact form submission on your website. Here
          are the details:
        </p>

        {/* Submission Details Card */}
        <div
          style={{
            backgroundColor: "#f5f9ff",
            padding: "20px",
            borderRadius: "8px",
            margin: "20px 0",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            borderLeft: "4px solid #0066cc",
          }}
        >
          <h3
            style={{
              margin: "0 0 15px 0",
              color: "#0066cc",
              fontSize: "18px",
            }}
          >
            Contact Details
          </h3>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    padding: "10px",
                    fontWeight: "600",
                    width: "30%",
                    verticalAlign: "top",
                  }}
                >
                  Name:
                </td>
                <td
                  style={{
                    padding: "10px",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                >
                  {data.name}
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    padding: "10px",
                    fontWeight: "600",
                    verticalAlign: "top",
                  }}
                >
                  Email:
                </td>
                <td
                  style={{
                    padding: "10px",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    wordBreak: "break-all",
                  }}
                >
                  {data.email}
                </td>
              </tr>

 <tr>
                <td
                  style={{
                    padding: "10px",
                    fontWeight: "600",
                    verticalAlign: "top",
                  }}
                >
                  Contact Number:
                </td>
                <td
                  style={{
                    padding: "10px",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    wordBreak: "break-all",
                  }}
                >
                  {data.contactNo}
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    padding: "10px",
                    fontWeight: "600",
                    verticalAlign: "top",
                  }}
                >
                  Subject:
                </td>
                <td
                  style={{
                    padding: "10px",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                >
                  {data.formSubject}
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    padding: "10px",
                    fontWeight: "600",
                    verticalAlign: "top",
                  }}
                >
                  Message:
                </td>
                <td
                  style={{
                    padding: "10px",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {data.message}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            margin: "25px 0",
          }}
        >
          <a
            href={`mailto:${data.email}?subject=Re: ${encodeURIComponent(
              data.subject
            )}`}
            style={{
              background: "#0066cc",
              color: "white",
              padding: "10px 20px",
              borderRadius: "4px",
              textDecoration: "none",
              fontWeight: "500",
              fontSize: "15px",
            }}
          >
            Reply to Sender
          </a>
        </div>

        {/* Footer */}
        <div
          style={{
            borderTop: "1px solid #e1e1e1",
            paddingTop: "20px",
            marginTop: "25px",
            textAlign: "center",
            color: "#666666",
            fontSize: "13px",
          }}
        >
          <p style={{ margin: "0 0 10px 0" }}>
            This is an automated notification from your {companyName} website
            contact form.
          </p>
          <p style={{ margin: "0" }}>
            © {new Date().getFullYear()} {companyName}. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

const FromResponseFormatToTool = (data, companyName = "Mento") => {
  const { name, score, assessment } = data;

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        maxWidth: "600px",
        margin: "auto",
        backgroundColor: "#ffffff",
        padding: "30px",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        color: "#333",
      }}
    >
      <h2 style={{ color: "#00b09b" }}>Hi {name},</h2>

      <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
        Thank you for completing the <strong>Self-Assessment Test</strong>.
      </p>

      <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
        Here’s a quick summary of your result and what it means for your
        emotional well-being:
      </p>

      <div
        style={{
          backgroundColor: "#f0fdf4",
          borderLeft: "5px solid #00b09b",
          padding: "20px",
          borderRadius: "8px",
          margin: "20px 0"
        }}>
          <p style={{ margin: 0, fontSize: "18px" }}><strong>Your Well-being Score:</strong> {score}</p>
          <p style={{ margin: "5px 0 0 0", fontSize: "18px" }}><strong>Assessment:</strong> {assessment}</p>
        </div>
  
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          This score suggests you may be going through significant emotional challenges right now.
          It’s important to take your well-being seriously, and seeking professional support can help you feel better and more in control.
        </p>
  
        <h3 style={{ color: "#00b09b", marginTop: "30px" }}>What You Can Do Next:</h3>
        <ul style={{ paddingLeft: "20px", fontSize: "16px", lineHeight: "1.6" }}>
          <li><strong>0–4 (None to Minimal):</strong> You're doing well. Keep up your self-care habits, and know we’re here if you ever need to talk.</li>
          <li><strong>5–9 (Mild Distress):</strong> You may be feeling a bit off or emotionally low. Mindfulness and talking to someone can help. A short session with a counselor might also give clarity.</li>
          <li><strong>10–14 (Moderate Distress):</strong> Your results show some emotional challenges. Therapy can help you better understand and manage these feelings.</li>
          <li><strong>15–19 (Moderately Severe):</strong> You're likely facing emotional difficulties. Talking to a professional could be a powerful first step toward feeling better. We strongly recommend scheduling a session.</li>
          <li><strong>20+ (Severe Distress):</strong> Your emotional well-being matters. Please don’t wait—our experts are here to support you through this.</li>
        </ul>
  
        <h3 style={{ color: "#00b09b", marginTop: "30px" }}>You Are Not Alone</h3>
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          No matter your score, help is always available. If you’d like to talk, we’re here to guide you toward a healthier, more balanced state of mind.
        </p>
  
        <div style={{ textAlign: "center", margin: "30px 0" }}>
          <a
            href="https://mento.in"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              backgroundColor: "#00b09b",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "5px",
              textDecoration: "none",
              fontWeight: "600"
            }}
          >
            Click here to book a session
          </a>
        </div>
  
        <p style={{ fontSize: "16px", color: "#555", lineHeight: "1.5" }}>Take care,</p>
        <p style={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}>Team {companyName}</p>
      </div>
    );
  };
  

export { FormResponseFormatToMento1,FormResponseFormatToUser, GenerateEmailHTML ,FromResponseFormatToContactus,FromResponseFormatToTool,UserPaymentConfirmation, UserPaymentConfirmationToMento };